<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
  <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>
<div
  *ngIf="dashboardAlert"
  class="mrf-dashboard-alert"
  [style.background-color]="getDashboardAlertBackground(dashboardAlert.status)"
  role="alert"
>
  <span class="mrf-dashboard-alert__text">{{ dashboardAlert.message }}</span>
  <button type="button" class="mrf-dashboard-alert__close" (click)="dismissDashboardAlert()" aria-label="Close">
    &times;
  </button>
</div>
<body>
  <div class="bodyContainer">
    <div class="overallDataContainer">
      <span class="textFont text_blue_color">MRF Dashboard</span>
      <div class="summaryPeriodControls" role="group" aria-label="Summary period">
        <button
          type="button"
          class="summaryPeriodBtn"
          [class.summaryPeriodBtn--active]="selectedSummaryPeriod === 'all'"
          (click)="onSummaryPeriodSelect('all')"
        >
          All
        </button>
        <div class="summaryMonthPickerWrap" (click)="$event.stopPropagation()">
          <button
            type="button"
            class="summaryMonthPicker"
            [class.summaryMonthPicker--active]="selectedSummaryPeriod !== 'all'"
            [attr.aria-expanded]="summaryMonthMenuOpen"
            (click)="toggleSummaryMonthMenu()"
            aria-label="Select month"
          >
            <svg
              class="summaryMonthPicker__icon"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <rect x="3" y="5" width="18" height="16" rx="2" stroke="currentColor" stroke-width="1.5" />
              <path d="M3 9H21" stroke="currentColor" stroke-width="1.5" />
              <path d="M8 3V7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
              <path d="M16 3V7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
            </svg>
            <span class="summaryMonthPicker__label">{{ summaryMonthLabel }}</span>
          </button>
          <div class="summaryMonthMenu" *ngIf="summaryMonthMenuOpen" role="listbox" aria-label="Months">
            <div class="summaryMonthMenu__year">
              <button type="button" class="summaryMonthMenu__nav" (click)="shiftSummaryMonthYear(-1)" aria-label="Previous year">
                ‹
              </button>
              <span>{{ summaryBrowseYear }}</span>
              <button
                type="button"
                class="summaryMonthMenu__nav"
                (click)="shiftSummaryMonthYear(1)"
                [disabled]="!canGoNextSummaryYear"
                aria-label="Next year"
              >
                ›
              </button>
            </div>
            <div class="summaryMonthMenu__grid">
              <button
                type="button"
                class="summaryMonthMenu__month"
                *ngFor="let label of monthShortLabels; let i = index"
                [class.summaryMonthMenu__month--active]="
                  selectedSummaryPeriod === i + 1 && summaryMonthYear === summaryBrowseYear
                "
                [class.summaryMonthMenu__month--disabled]="isSummaryMonthDisabled(i + 1)"
                [disabled]="isSummaryMonthDisabled(i + 1)"
                (click)="selectSummaryMonth(i + 1)"
              >
                {{ label }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="dataContainer">
      <ng-container *ngFor="let item of mrfData">
        <span
          class="subDataContainer box_shadow statusCard"
          *ngIf="item"
          [class.statusCardActive]="isStatusCardActive(item.statusName)"
          [class.statusCardDisabled]="rolesLoaded && !canAccessStatusCard(item.statusName)"
          (click)="onStatusCardClick(item.statusName)"
        >
          <div class="imageContainer">
            <img
              class="imgIcon"
              [style.width.%]="isPendingStatus(item.statusName) ? 14 : null"
              [src]="getIcon(item.statusName)"
              alt=""
            />
            <div class="flex_col">
              <span style="font-size: 24px">{{ item.count }}</span>
              <span class="status-label">{{ getStatusLabel(item.statusName) }}</span>
            </div>
          </div>
          <div style="margin-left: 10%">
            <div
              style="
                display: flex;
                height: 6px;
                width: 90%;
                border-radius: 10px;
                background-color: #d9d9d9;
              "
            >
              <div
                [style.backgroundColor]="getBarColor(item.statusName)"
                [style.width.%]="item.trackPercentage"
                style="border-radius: 10px"
              ></div>
            </div>
          </div>
        </span>
      </ng-container>
    </div>
    <div class="content box_shadow table_container">
      <div class="trackHeaderRow">
        <span class="graphtitledata">MRF Track Details</span>
        <div class="trackHeaderActions">
          <button
            type="button"
            class="filterTrigger"
            *ngIf="canCreateRequest"
            (click)="createRequest()"
            aria-label="Create request"
          >
            <img src="assets/image/addIcon.svg" alt="" class="filterTrigger__icon" />
            <span>Create</span>
          </button>
          <button
            type="button"
            class="filterTrigger"
            disabled
            aria-label="Open filter"
            aria-disabled="true"
          >
            <img src="assets/image/grievance/filter.svg" alt="" class="filterTrigger__icon" />
            <span>Filter</span>
          </button>
          <button
            type="button"
            class="filterTrigger"
            (click)="openCustomizeFilterDialog()"
            aria-label="Open customize filter"
          >
            <img src="assets/image/grievance/filter.svg" alt="" class="filterTrigger__icon" />
            <span>Customize Filter</span>
          </button>
          <button
            type="button"
            class="excelExportBtn"
            [class.excelExportBtn--disabled]="!canExportExcel"
            [disabled]="!canExportExcel"
            (click)="exportToExcel()"
            aria-label="Download Excel"
          >
            <img src="assets/image/vscode-icons_file-type-excel.svg" alt="" class="excelExportBtn__icon" />
            <span>Excel</span>
          </button>
        </div>
      </div>
      <hr />
      <div class="tabsRow" *ngIf="hasDashboardAccess">
        <div class="tabsRow__tabs">
          <button
            type="button"
            *ngFor="let tab of visibleTabs"
            class="tabBtn"
            [class.tabBtnActive]="activeTab === tab"
            (click)="setTab(tab)"
          >
            {{ tab }}
          </button>
        </div>
        <select
          class="trackSelect tabsRow__period"
          aria-label="Select period"
          [ngModel]="selectedTrackDuration"
          (ngModelChange)="onTrackDurationChange($event)"
        >
          <option value="1MONTH">Last month</option>
          <option value="2MONTH">Last 2 months</option>
          <option value="3MONTH">Last 3 months</option>
        </select>
      </div>
      <div
        *ngIf="rolesLoaded && !hasDashboardAccess"
        class="mrf-dashboard-permission-error"
        role="alert"
      >
        No permission to access this.
      </div>
      <hr *ngIf="hasDashboardAccess || (rolesLoaded && !hasDashboardAccess)" />
      <input
        *ngIf="hasDashboardAccess"
        type="text"
        class="input"
        [value]="quickFilter"
        (input)="onQuickFilterChanged($event)"
        placeholder="Search..."
      />
      <ag-grid-angular
        *ngIf="hasDashboardAccess"
        style="width: 98%; height: 350px; overflow-x: scroll; margin-left: 1%"
        [rowData]="displayRowData"
        [pinnedTopRowData]="pinnedTopRowData"
        [columnDefs]="colDefs"
        [defaultColDef]="defaultColDef"
        [quickFilterText]="quickFilter"
        [defaultExcelExportParams]="defaultExcelExportParams"
        (gridReady)="onGridReady($event)"
        (bodyScroll)="onViewMenuScroll()"
      />
      <ul
        *ngIf="viewMenuOpen"
        class="mrf-view-menu"
        [style.top.px]="viewMenuTop"
        [style.left.px]="viewMenuLeft"
        [style.minWidth.px]="viewMenuMinWidth"
        (click)="onViewMenuClick($event)"
        role="listbox"
        aria-label="MRF view options"
      >
        <li *ngFor="let option of viewMenuOptions" role="option">
          <button type="button" class="mrf-view-menu__option" (click)="selectViewOption(option, $event)">
            {{ option.label }}
          </button>
        </li>
      </ul>
    </div>
  </div>
</body>





